import { useQuery } from '@tanstack/react-query';

import { orpc } from '@/lib/api/orpc';

const STALE_TIME = 5 * 60 * 1000; // 5 分

/** Slot 1〜6 を集約した count レスポンス */
export const useContractOverviewCount = () => {
  return useQuery({
    ...orpc.contractOverview.count.queryOptions(),
    staleTime: STALE_TIME,
  });
};

/** Slot 7 — 月初〜翌月末の満了予定リスト */
export const useContractOverviewSchedule = () => {
  return useQuery({
    ...orpc.contractOverview.schedule.queryOptions(),
    staleTime: STALE_TIME,
  });
};

/** Slot 8 — 直近 5 件のアクティビティ */
export const useContractOverviewActivity = () => {
  return useQuery({
    ...orpc.contractOverview.activity.queryOptions(),
    staleTime: STALE_TIME,
  });
};
